import { render, staticRenderFns } from "./PropertyFilter.vue?vue&type=template&id=47d5b9d8&scoped=true&"
import script from "./PropertyFilter.vue?vue&type=script&lang=js&"
export * from "./PropertyFilter.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFilter.vue?vue&type=style&index=0&id=47d5b9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d5b9d8",
  null
  
)

export default component.exports